<template>
  <div class="audio-hero-image">
    <div class="audio-hero-image__container">
      <pict
        block-name="audio-hero-image__phone"
        :default="imageSources[0]"
        :sources="imageSources" />
    </div>
  </div>
</template>

<script>
import Pict from "shared/pict.vue";
import getLocale from "@/utils/locale";

import phoneImage from "./images/phones.png";
import phoneImage2x from "./images/phones@2x.png";
import phoneImageTablet from "./images/phones_tablet.png";
import phoneImage2xTablet from "./images/phones_tablet@2x.png";
import phoneImageMobile from "./images/phones_mobile.png";
import phoneImage2xMobile from "./images/phones_mobile@2x.png";

import phoneImageDE from "./images/phones_de.png";
import phoneImage2xDE from "./images/phones_de@2x.png";
import phoneImageTabletDE from "./images/phones_tablet_de.png";
import phoneImage2xTabletDE from "./images/phones_tablet_de@2x.png";
import phoneImageMobileDE from "./images/phones_mobile_de.png";
import phoneImage2xMobileDE from "./images/phones_mobile_de@2x.png";

export default {
  name: "AudioeHeroImage",
  components: {
    Pict
  },
  computed: {
    imageSources() {
      if (getLocale() === "de") {
        return [
          {
            media: "l",
            src: phoneImageDE,
            srcset: {
              "2x": phoneImage2xDE
            }
          },
          {
            media: "m",
            src: phoneImageTabletDE,
            srcset: {
              "2x": phoneImage2xTabletDE
            }
          },
          {
            media: "xs",
            src: phoneImageMobileDE,
            srcset: {
              "2x": phoneImage2xMobileDE
            }
          }
        ];
      }
      return [
        {
          media: "l",
          src: phoneImage,
          srcset: {
            "2x": phoneImage2x
          }
        },
        {
          media: "m",
          src: phoneImageTablet,
          srcset: {
            "2x": phoneImage2xTablet
          }
        },
        {
          media: "xs",
          src: phoneImageMobile,
          srcset: {
            "2x": phoneImage2xMobile
          }
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>

.audio-hero-image {
  position: relative;

  display: grid;

  text-align: center;

  background: url("./images/background_wave_mobile.svg") no-repeat top right;
  background-size: cover;

  &:after {
    content: "";

    position: absolute;
    top: 0;
    left: 100%;
    z-index: 0;

    display: block;
    width: 100vw;
    height: 100%;

    background-color: $blue;
  }

  &__container {
    margin-bottom: 0;
    grid-area: 1 / 1 / 1 / 8;

    padding: 0 $spacing-32;

    @include media(min-width,m) {
      /* stylelint-disable-next-line unit-blacklist */
      margin-bottom: spacing(145px);
      padding: 0;
    }

    @include media(min-width,l) {
      margin-bottom: 0;
    }
  }

  /* stylelint-disable-next-line */
  ::v-deep &__phone__image {
    position: relative;
    /* stylelint-disable-next-line unit-blacklist */
    bottom: spacing(-45px);
    z-index: 1;

    width: 100%;
    max-width: 500px;

    @include media(min-width, m) {
      /* stylelint-disable-next-line unit-blacklist */
      bottom: spacing(-195px);

      width: auto;
      max-width: auto;
    }

    @include media(min-width, l) {
      /* stylelint-disable-next-line unit-blacklist */
      bottom: spacing(-60px);
    }
  }

  @include media(min-width, m) {
    text-align: right;

    background-image: url("./images/background_wave_tablet.svg");
    background-position: bottom right;
    background-size: contain;
  }

  @include media(min-width, l) {
    background-image: url("./images/background_wave.svg");
  }
}

</style>
